import { Component, Input } from '@angular/core';

import { ModalController, ToastController, AlertController, LoadingController, Events, PopoverController } from 'ionic-angular';
import { AlertMessager } from '../../../../lib/alertMessager';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/mergeMap';
import { PaymentService } from '../../../../services/payment.service';
import { RunService } from '../../../../services/run.service';
import { OrganizationService } from '../../../../services/organization.service';
import { Account } from '../../../../model/account';
import { UserService } from '../../../../services/user.service';
import { UserSearchPopover } from '../../../../pages/search/user-search';

@Component({
    selector: 'staff-staff-access',
    templateUrl: 'staff-access.html'
})
export class StaffAccessSection {
    @Input('organization') organization;

    roleFilter: string = 'Any';

    searchChangeObservable;
    searchQuery: string;
    searchResults: any = [];

    staffSearchChangeObservable;
    staffResults: any = [];
    firstName: string;
    lastName: string;

    staffAccounts: any[];

    popoverActive: boolean;
    loadingData: boolean;

    nameSortAsc: boolean = true;
    nameSortDesc: boolean;

    constructor(private modalCtrl: ModalController, private alertController: AlertController, private alert: AlertMessager, private loadingController: LoadingController,
        private userService: UserService, private toast: ToastController, private popoverController: PopoverController, private paymentService: PaymentService,
        public events: Events, private organizationService: OrganizationService, private runService: RunService) {

        
    }

    load() {
        this.getStaffForOrganization();
    }

    getStaffForOrganization() {
        console.log('getStaffForOrg call');
        this.organizationService.getAllStaffAccounts(this.organization.id)
            .then((data) => {
                this.staffAccounts = (data as Account[]);

                this.staffAccounts.forEach(x => {
                    x.roleId = x.roles.filter(y => y.organizationId == this.organization.id)[0].roleId;
                });

                this.filterStaff();
            }, error => {
                console.log("Error retrieving all staff accounts: ", error);
            })
    }

    getSearchMessage() {
        if (this.loadingData)
            return "";

        if (this.searchQuery == undefined || this.searchQuery.trim().length == 0)
            return "";
        else if (this.searchResults == undefined || this.searchResults.length < 1) {
            return "There are no staff account under this organization by that name.";
        }

        return "";
    }

    onFirstNameSearchChange(searchValue: string) {
        this.onStaffSearchChange('firstName' + searchValue);
    }

    onLastNameSearchChange(searchValue: string) {
        this.onStaffSearchChange('lastName' + searchValue);
    }

    onRoleFilterChange(searchValue: string) {
        this.onStaffSearchChange('roleFilter' + searchValue);
    }

    onStaffSearchChange(searchValue: string) {
        if (!this.staffSearchChangeObservable) {
            Observable.create(observer => {
                this.staffSearchChangeObservable = observer;
            }).debounceTime(300)
                .distinctUntilChanged()
                .subscribe((text) => { this.filterStaff() });
        }

        this.staffSearchChangeObservable.next(searchValue);
    }

    filterStaff() {
        this.staffResults = this.staffAccounts;

        if (this.roleFilter !== 'Any') {
            this.staffResults = this.staffAccounts.filter(x => x.roles.some(y => y.organizationid == this.organization.id && y.roleId == this.roleFilter));
        }

        if (this.firstName) {
            this.staffResults = this.staffResults.filter(x =>
                x.firstName && x.firstName.toLowerCase().indexOf(this.firstName.toLocaleLowerCase()) > -1);
        }

        if (this.lastName) {
            this.staffResults = this.staffResults.filter(x =>
                x.lastName && x.lastName.toLowerCase().indexOf(this.lastName.toLocaleLowerCase()) > -1);
        }

        this.sortStaff();

        console.log("staff results: ", this.staffResults);
    }

    toggleNameSort() {
        if (this.nameSortAsc) {
            this.nameSortAsc = false;
            this.nameSortDesc = true;
        } else {
            this.nameSortAsc = true;
            this.nameSortDesc = false;
        }

        this.sortStaff();
    }

    sortStaff() {
        this.staffResults = this.staffResults.sort((n1, n2) => {
            if (this.nameSortAsc || this.nameSortDesc) {
                if (n1.firstName < n2.firstName)
                    return this.nameSortDesc ? 1 : -1;
                else if (n1.firstName > n2.firstName)
                    return this.nameSortDesc ? -1 : 1;

                if (n1.lastName < n2.lastName)
                    return this.nameSortDesc ? 1 : -1;
                else if (n1.lastName > n2.lastName)
                    return this.nameSortDesc ? -1 : 1;

                if (n1.id < n2.id)
                    return -1;
                else if (n1.id > n2.id)
                    return 1;
            }
        });
    }

    addNewStaff() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let popover = this.popoverController.create(UserSearchPopover, {
            searchTitle: "Search Accounts",
            organizations: [this.organization]
        }, { cssClass: 'user-search' });

        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;

            if (data && data.buddies && data.buddies.length > 0) {
                data.buddies[0].permission = 2;
                this.staffAccounts.unshift(data.buddies[0]);
            }
        })
    }

    updateStaffRole(staff: any) {
        this.userService.updateUserRole(staff, this.organization.id, staff.roleId)
            .then(data => {
                if (data == null || data == undefined) {
                    if (staff.roleId == 0)
                        this.staffAccounts = this.staffAccounts.filter(x => x.id != staff.id);

                    staff.status = 'Role updated!';
                    this.filterStaff();
                } else if ((data as any).message != null && (data as any).message != undefined) {
                    staff.status = (data as any).message;
                }
            }, error => {
                this.alert.showError("Role Update Error", error);
            });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/organization/staff-access/staff-access.ts